<template>
  <div>
    <div class="text-center text-h6 pb-1">
      Vos informations
    </div>
    <v-form @submit.prevent.native="submit">
      <div class="pt-2 pb-0 mb-6" v-if="hasError">
        <v-alert
          text
          :icon="false"
          type="error"
        >
          <div slot="prepend" class="pr-3">
            😱
          </div>
          {{ error }}
        </v-alert>
      </div>
      <div class="mt-5 pl-1 pb-1">
        <label class="font-weight-medium">
          Votre prénom
        </label>
      </div>
      <v-text-field
        v-model="firstname"
        outlined
        persistent-placeholder
        hide-details
        background-color="rgba(234, 239, 247, 0.4)"
        autofocus
      />
      <div class="mt-5 pl-1 pb-1">
        <label class="font-weight-medium">
          Votre nom
        </label>
      </div>
      <v-text-field
        v-model="lastname"
        outlined
        persistent-placeholder
        hide-details
        background-color="rgba(234, 239, 247, 0.4)"
      />
      <div class="mt-5 pl-1 pb-1">
        <label class="font-weight-medium">
          Votre e-mail
        </label>
      </div>
      <v-text-field
        v-model="email"
        outlined
        persistent-placeholder
        hide-details
        background-color="rgba(234, 239, 247, 0.4)"
      />
      <div class="text-caption pl-1 pt-1">
        <v-icon small color="primary" v-if="!this.cleanEmail.length">more_horiz</v-icon>
        <v-icon small color="success" v-else-if="isEmailValid">done</v-icon>
        <v-icon small color="error" v-else>clear</v-icon>
        Adresse email valide
      </div>
      <div class="mt-5 pl-1 pb-1">
        <label class="font-weight-medium">
          Votre mot de passe
        </label>
      </div>
      <v-text-field
        v-model="password"
        outlined
        :type="isShowingPassword ? `text` : `password`"
        persistent-placeholder
        :prepend-inner-icon="isShowingPassword ? `visibility_off` : `visibility`"
        hide-details
        background-color="rgba(234, 239, 247, 0.4)"
        @click:prepend-inner="isShowingPassword = !isShowingPassword"
      />
      <div class="text-caption pl-1 pt-1">
        <div>
          <v-icon small color="primary" v-if="!this.password.length">more_horiz</v-icon>
          <v-icon small color="success" v-else-if="isPasswordLengthValid">done</v-icon>
          <v-icon small color="error" v-else>clear</v-icon>
          Doit faire au moins 8 caractères
        </div>
        <div>
          <v-icon small color="primary" v-if="!this.password.length">more_horiz</v-icon>
          <v-icon small color="success" v-else-if="isPasswordMixValid">done</v-icon>
          <v-icon small color="error" v-else>clear</v-icon>
          Au moins un chiffre et une lettre
        </div>
      </div>
      <v-row no-gutters justify="center" align="center" class="mt-10 mb-10">
        <v-btn
          type="submit"
          rounded
          depressed
          color="primary"
          class="submit-btn"
          :loading="isSubmitting"
          :disabled="!canSubmit"
        >
          Étape suivante 💪
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import _ from 'lodash';
import api from '@/api';
import { mapMutations } from 'vuex';

const MIN_MS_BEFORE_NEXT_STEP = 2000;
const DEFAULT_ERROR_MESSAGE = `Une erreur inconnue s'est produite, merci de réessayer`;

export default {
  data: () => ({
    firstname: ``,
    lastname: ``,
    email: ``,
    password: ``,
    isShowingPassword: false,
    isSubmitting: false,
    error: ``,
  }),

  computed: {
    hasError() {
      return this.error?.length > 0;
    },
    cleanFirstname() {
      return _.trim(this.firstname);
    },
    cleanLastname() {
      return _.trim(this.lastname);
    },
    cleanEmail() {
      return _.trim(this.email).toLowerCase();
    },
    isEmailValid() {
      return this.$isEmail(this.cleanEmail);
    },
    isPasswordLengthValid() {
      return this.password.length >= 8;
    },
    isPasswordMixValid() {
      return this.password.length
             && (/[A-Za-z]/).test(this.password)
             && (/[0-9]/).test(this.password);
    },
    isPasswordValid() {
      return this.isPasswordLengthValid && this.isPasswordMixValid;
    },
    canSubmit() {
      return this.cleanFirstname.length
             && this.cleanLastname.length
             && this.isEmailValid
             && this.isPasswordValid;
    },
  },

  methods: {
    ...mapMutations([
      `SET_SIGNUP`,
    ]),
    async submit() {
      this.isSubmitting = true;
      try {
        const startTs = Date.now();
        const endTs = Date.now();
        const duration = endTs - startTs;

        // const token = `fd6c3a13-2b23-451d-bc83-60ddda1e5ad7`;

        // if (this.firstname === `toto`) {
        //   console.log(api);
        // }

        const { data: { signup, success, error } } = await api.post(`/signup`, {
          firstname: this.cleanFirstname,
          lastname: this.cleanLastname,
          email: this.cleanEmail,
          password: this.password,
        });

        if (success && signup?.token) {
          this.SET_SIGNUP(signup);
          if (duration < MIN_MS_BEFORE_NEXT_STEP) {
            setTimeout(() => {
              this.submitEnded(signup.token);
            }, MIN_MS_BEFORE_NEXT_STEP - duration);
          } else {
            this.submitEnded(signup.token);
          }
        } else {
          this.error = error || DEFAULT_ERROR_MESSAGE;
          this.isSubmitting = false;
        }
      } catch (e) {
        this.error = DEFAULT_ERROR_MESSAGE;
      }
    },
    submitEnded(token) {
      this.isSubmitting = false;
      this.$router.replace(`/signup/${token}`);
    },
  },
};
</script>
